import styled, { css } from "styled-components";
import { Row } from "react-bootstrap";
import { getLocale } from "react-i18nify";

import device from "src/styles/device";
import { convertIntToCurrency } from "src/common";

import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";

import IconBgExclusiveDeal from "src/components/product/ProductCard/Icons/IconBgExclusiveDeal";
import { Green, Grey, Violet, White, White01 } from "src/styles/color";

const marginCarousel = css`
  margin-top: 5px;
  margin-bottom: 5px;
`;

const ProductCard = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  ${({ carousel }) => carousel && marginCarousel};
  transition: 0.2s;

  :hover {
    /* transform: scale(1.02); */

    #img-product-card {
      ${({ srcHover }) =>
        srcHover &&
        css`
          content: url(${({ srcHover }) => srcHover});
        `}
      transition: 0.3s;
    }
  }
`;

const Card = styled.div`
  width: 100%;
  background-color: #ffffff;
  box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.2);
  transition: 0.2s;
  border-radius: 12px;
  padding: 8px;

  @media ${device.mobileL} {
    border-radius: 12px;
  }
`;

const WrapperImage = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-radius: calc(7.2px);
`;

const EmptyImage = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--lightgrey-color);
`;

const EmptyText = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--white-color);
  text-align: center;
  white-space: pre-line;
  word-break: break-word;
  margin-top: 8px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  transition: 0.3s;
`;

const WrapperDetail = styled.div`
  border-radius: 12px 12px 0 0;
`;

const RowItemcodeView = styled(Row)`
  align-items: center;
  position: relative;
  width: 55%;
`;

const RowItemName = styled(Row)`
  align-items: center;
  position: relative;
  /* width: 55%; */
`;

const ItemName = styled.span`
  text-align: left;
  font-size: 0.75rem;
  font-family: Poppins, Prompt;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
  line-height: 18px;
  height: 36px;
  color: rgb(37, 37, 37);
`;

const ItemCode = styled.span`
  text-align: left;
  font-weight: ${({ type }) => (type ? "400" : "500")};
  color: rgb(108, 108, 112);
  font-size: 0.625rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  // text-align: left;
  // font-size: 0.75rem;
  // color: ${({ color }) => (color ? "var(--darkgrey-color)" : "#FFFFFF")};
  // font-weight: 400;
  // line-height: 15px;
  // border-radius: 5px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // font-family: "Poppins", "Prompt";
  // /* width: 60%;
  // position: absolute;
  // bottom: 10px;
  // left: 0; */
  // padding-left: 15px;

  @media ${device.mobileL} {
    font-size: 0.625rem;
  }
`;

const RowFirst = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  margin: 10px 0;
  flex-direction: column;

  @media ${device.tabletL} {
    padding: 10px 15px 2px 15px;
  }
  @media ${device.mobileL} {
    padding: 8px 10px 0px 10px;
  }
`;

const LabelItemName = styled.div`
  font-weight: 500;
  line-height: 18px;
  color: var(--secondary-color);
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Poppins", "Prompt";
  /* width: 75%; */
  width: 85%;
  text-align: left;

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const RowFifth = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 8px;

  @media ${device.mobileL} {
    /* padding: 4px 10px 0px 10px; */
  }
`;

const WrapperOldPrice = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  height: 15px;
  width: 100%;
  text-align: left;
  margin-bottom: 2px;
`;

const WrapperPrice = styled.div`
  width: 100%;
`;

const LabelPrice = styled.span`
  font-family: "Prompt", "Poppins";
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  max-width: 100%;
  font-size: 1.25rem;
  color: ${({ specialprice }) =>
    specialprice ? "var(--primary-color)" : "var(--secondary-color)"};
  margin-right: 3%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: normal;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
  @media ${device.mobileL} {
    font-size: 0.875rem;
  }
`;

const LabelPriceSmall = styled.div`
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 0.625rem;
  color: ${(props) =>
    props.specialprice ? "var(--primary-color)" : "var(--darkgrey-color)"};
  text-decoration: ${(props) => (props.isLineThrough ? "line-through" : null)};
`;

const LabelCurrency = styled.div`
  font-size: 0.625rem;
  color: ${({ specialprice }) =>
    specialprice ? "var(--primary-color)" : "var(--darkgrey-color)"};
  font-weight: 400;
  margin-right: 3%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Prompt", "Poppins";
  padding-top: 4px;
  height: 24px;
  @media ${device.tabletL} {
    font-size: 0.75rem;
  }
  @media ${device.mobileL} {
    font-size: 0.625rem;
  }
`;

const RowThird = styled.div`
  width: 100%;
  display: flex;
  padding: 0 15px 0 15px;
  height: 15px;
  text-align: left;
  @media ${device.tabletL} {
    padding: 0 15px 0 15px;
  }
  @media ${device.mobileL} {
    padding: 0 10px 0 10px;
  }
`;

const LabelCate = styled.div`
  font-size: 0.625rem;
  color: var(--darkgrey-color);
  font-weight: 400;
  line-height: 15px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Prompt", "Poppins";
`;

const LabelDiscount = styled.div`
  position: absolute;
  top: 3%;
  right: 5%;
  background: #d70015;
  padding: 1px 4px;
  z-index: 1;
  color: #ffffff;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 15px;
  border-radius: 4px;

  &::before {
    background: #d9d9d9;
    border-radius: 100%;
    content: "";
    display: block;
    position: absolute;
    width: 2px;
    height: 2px;
    top: 10%;
    left: 5%;
  }
`;

const WrapperIconBgExclusiveDeal = styled.div`
  position: absolute;
  top: 3%;
  left: 5%;
  z-index: 1;
`;

const PriceUnitFlex = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: -8px;
`;

const ClickProductCard = styled.a`
  display: ${({ flex }) => flex && "flex"};
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ProductSize = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  color: rgb(37, 37, 37);
  font-size: 0.625rem;
  height: 12px;
  margin-top: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const SectionPrice = styled.div`
  display: flex;
  width: 70%;
  align-items: flex-end;
`;

const ButtonAddToCart = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${Green};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: absolute;
  bottom: 10px;
  right: 10px;

  :hover {
    transform: scale(1.1);
  }

  ${({ isPreOrder }) =>
    isPreOrder &&
    css`
      font-size: 0.55rem;
      font-weight: 600;
      background-color: ${Grey};
      color: ${White01};

      :hover {
        cursor: no-drop;
        transform: scale(1);
      }
    `}

  ${({ checkStock }) =>
    checkStock &&
    css`
      font-size: 0.5rem;
      font-weight: 600;
      background-color: ${White};
      color: ${Grey};

      :hover {
        cursor: no-drop;
        transform: scale(1);
      }
    `}

  transition: 0.3s;

  @media ${device.mobileL} {
    width: 37px;
    height: 37px;
  }
`;

const LabelInstall = styled.div`
  background: #e0d4f9;
  border: 1px solid ${Violet};
  color: ${Violet};
  padding: 3px 4px 2px 4px;
  border-radius: 6px;
  font-size: 8px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-left: ${({ isMargin }) => isMargin && "5px"};
`;

const GradientItemCode = styled.div`
  background: linear-gradient(
    360deg,
    rgba(37, 37, 37, 0.4) 0%,
    rgba(37, 37, 37, 0) 100%
  );
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 35px;
  display: flex;
  /* justify-content: ce; */
  /* align-content: space-between; */
  align-items: center;
  border-radius: 0 0 8px 8px;
  padding: 0 5%;
`;

const ProductCardElement = ({
  src,
  srcHover = null,
  emptyImage,
  itemcode,
  itemname,
  price = null,
  productType,
  view,
  id,
  color,
  texture,
  size,
  carousel,
  newTab,
  unit,
  discount,
  isExclusiveDeal,
  colorCode,
  sellerLogo,
  sellerName,
  display = false,
  onClickDelete,
  isPreOrder = false,
  isInstock = false,
  isInstall = false,
}) => {
  return (
    <>
      <ProductCard carousel={carousel} srcHover={srcHover}>
        {isExclusiveDeal && (
          <WrapperIconBgExclusiveDeal>
            <IconBgExclusiveDeal />
          </WrapperIconBgExclusiveDeal>
        )}

        {discount && discount > 0 && discount < 100 ? (
          <LabelDiscount>{`- ${Math.floor(discount)}%`}</LabelDiscount>
        ) : null}

        {newTab === undefined || newTab === false ? (
          <Card>
            <WrapperDetail>
              <ClickProductCard flex>
                {emptyImage ? (
                  <WrapperImage>
                    <EmptyImage>
                      <AddPhotoAlternateOutlinedIcon
                        sx={{
                          fontSize: 42,
                          color: "var(--white-color)",
                        }}
                      />
                      <EmptyText>{`*ขนาดไฟล์สูงสุด\nไม่เกิน 2MB`}</EmptyText>
                    </EmptyImage>
                  </WrapperImage>
                ) : (
                  <WrapperImage>
                    <Image
                      src={src}
                      id="img-product-card"
                      alt={`${itemname} (${itemcode})`}
                    />

                    {isInstall && (
                      <GradientItemCode>
                        <LabelInstall>
                          <svg
                            width={15}
                            height={10}
                            viewBox="0 0 24 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "3px" }}
                          >
                            <path
                              d="M0 20V16.8889C0 16.2778 0.155251 15.7037 0.465753 15.1667C0.776256 14.6296 1.20548 14.2222 1.75342 13.9444C2.68493 13.463 3.73516 13.0556 4.90411 12.7222C6.07306 12.3889 7.36073 12.2222 8.76712 12.2222C10.1735 12.2222 11.4612 12.3889 12.6301 12.7222C13.7991 13.0556 14.8493 13.463 15.7808 13.9444C16.3288 14.2222 16.758 14.6296 17.0685 15.1667C17.379 15.7037 17.5342 16.2778 17.5342 16.8889V20H0ZM8.76712 11.1111C7.56164 11.1111 6.52968 10.6759 5.67123 9.80556C4.81279 8.93518 4.38356 7.88889 4.38356 6.66667H4.10959C3.94521 6.66667 3.81297 6.61593 3.71288 6.51444C3.61206 6.41222 3.56164 6.27778 3.56164 6.11111C3.56164 5.94444 3.61206 5.81 3.71288 5.70778C3.81297 5.6063 3.94521 5.55556 4.10959 5.55556H4.38356C4.38356 4.72222 4.58448 3.97222 4.9863 3.30556C5.38813 2.63889 5.91781 2.11111 6.57534 1.72222V2.77778C6.57534 2.94444 6.62575 3.07852 6.72658 3.18C6.82667 3.28222 6.9589 3.33333 7.12329 3.33333C7.28767 3.33333 7.42027 3.28222 7.5211 3.18C7.62119 3.07852 7.67123 2.94444 7.67123 2.77778V1.27778C7.83562 1.22222 8.00913 1.18037 8.19178 1.15222C8.37443 1.12482 8.56621 1.11111 8.76712 1.11111C8.96804 1.11111 9.15982 1.12482 9.34247 1.15222C9.52511 1.18037 9.69863 1.22222 9.86301 1.27778V2.77778C9.86301 2.94444 9.91342 3.07852 10.0142 3.18C10.1143 3.28222 10.2466 3.33333 10.411 3.33333C10.5753 3.33333 10.7079 3.28222 10.8088 3.18C10.9089 3.07852 10.9589 2.94444 10.9589 2.77778V1.72222C11.6164 2.11111 12.1461 2.63889 12.5479 3.30556C12.9498 3.97222 13.1507 4.72222 13.1507 5.55556H13.4247C13.589 5.55556 13.7216 5.6063 13.8225 5.70778C13.9226 5.81 13.9726 5.94444 13.9726 6.11111C13.9726 6.27778 13.9226 6.41222 13.8225 6.51444C13.7216 6.61593 13.589 6.66667 13.4247 6.66667H13.1507C13.1507 7.88889 12.7215 8.93518 11.863 9.80556C11.0046 10.6759 9.9726 11.1111 8.76712 11.1111ZM8.76712 8.88889C9.36986 8.88889 9.88603 8.67111 10.3156 8.23556C10.7445 7.80074 10.9589 7.27778 10.9589 6.66667H6.57534C6.57534 7.27778 6.79014 7.80074 7.21973 8.23556C7.64858 8.67111 8.16438 8.88889 8.76712 8.88889ZM16.9863 13.3333L16.8219 12.5C16.7123 12.463 16.6075 12.4211 16.5074 12.3744C16.4066 12.3285 16.3105 12.2593 16.2192 12.1667L15.4521 12.4444L14.9041 11.4444L15.5068 10.8889V10.2222L14.9041 9.66667L15.4521 8.66667L16.2192 8.94444C16.2922 8.87037 16.3836 8.80556 16.4932 8.75C16.6027 8.69444 16.7123 8.64815 16.8219 8.61111L16.9863 7.77778H18.0822L18.2466 8.61111C18.3562 8.64815 18.4658 8.69444 18.5753 8.75C18.6849 8.80556 18.7763 8.87037 18.8493 8.94444L19.6164 8.66667L20.1644 9.66667L19.5616 10.2222V10.8889L20.1644 11.4444L19.6164 12.4444L18.8493 12.1667C18.758 12.2593 18.6623 12.3285 18.5622 12.3744C18.4614 12.4211 18.3562 12.463 18.2466 12.5L18.0822 13.3333H16.9863ZM17.5342 11.3889C17.7534 11.3889 17.9452 11.3056 18.1096 11.1389C18.274 10.9722 18.3562 10.7778 18.3562 10.5556C18.3562 10.3333 18.274 10.1389 18.1096 9.97222C17.9452 9.80556 17.7534 9.72222 17.5342 9.72222C17.3151 9.72222 17.1233 9.80556 16.9589 9.97222C16.7945 10.1389 16.7123 10.3333 16.7123 10.5556C16.7123 10.7778 16.7945 10.9722 16.9589 11.1389C17.1233 11.3056 17.3151 11.3889 17.5342 11.3889ZM19.5068 7.77778L19.2877 6.61111C19.1233 6.55556 18.9728 6.48593 18.8362 6.40222C18.6988 6.31926 18.5753 6.22222 18.4658 6.11111L17.3151 6.5L16.5479 5.16667L17.4795 4.33333C17.4429 4.24074 17.4247 4.16667 17.4247 4.11111V3.66667C17.4247 3.61111 17.4429 3.53704 17.4795 3.44444L16.5479 2.61111L17.3151 1.27778L18.4658 1.66667C18.5753 1.55556 18.6988 1.45815 18.8362 1.37444C18.9728 1.29148 19.1233 1.22222 19.2877 1.16667L19.5068 0H21.0411L21.2603 1.16667C21.4247 1.22222 21.5755 1.29148 21.7129 1.37444C21.8495 1.45815 21.9726 1.55556 22.0822 1.66667L23.2329 1.27778L24 2.61111L23.0685 3.44444C23.105 3.53704 23.1233 3.61111 23.1233 3.66667V4.11111C23.1233 4.16667 23.105 4.24074 23.0685 4.33333L24 5.16667L23.2329 6.5L22.0822 6.11111C21.9726 6.22222 21.8495 6.31926 21.7129 6.40222C21.5755 6.48593 21.4247 6.55556 21.2603 6.61111L21.0411 7.77778H19.5068ZM20.274 5.27778C20.6575 5.27778 20.9819 5.14333 21.2471 4.87444C21.5116 4.6063 21.6438 4.27778 21.6438 3.88889C21.6438 3.5 21.5116 3.17111 21.2471 2.90222C20.9819 2.63407 20.6575 2.5 20.274 2.5C19.8904 2.5 19.5664 2.63407 19.3019 2.90222C19.0367 3.17111 18.9041 3.5 18.9041 3.88889C18.9041 4.27778 19.0367 4.6063 19.3019 4.87444C19.5664 5.14333 19.8904 5.27778 20.274 5.27778Z"
                              fill={
                                color ? color : "url(#paint0_linear_435_14943)"
                              }
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_435_14943"
                                x1="-3.57628e-07"
                                y1="20"
                                x2="24"
                                y2="2.26498e-06"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor={color ? color : "#D70015"} />
                                <stop
                                  offset="1"
                                  stopColor={color ? color : "#E13B30"}
                                  stopOpacity="0.6"
                                />
                              </linearGradient>
                            </defs>
                          </svg>
                          ติดตั้งฟรี
                        </LabelInstall>
                      </GradientItemCode>
                    )}
                  </WrapperImage>
                )}
              </ClickProductCard>

              <RowFirst>
                <ItemName>{itemname}</ItemName>
                <ItemCode>รหัส : {itemcode}</ItemCode>
                <ItemCode type>{productType}</ItemCode>
                <ProductSize>
                  {typeof size !== "string"
                    ? // size object
                      size?.quantity === "capacity"
                      ? `${size?.capacity_size} 
                          ${
                            getLocale() === "th"
                              ? //? `ลิตร` : `liter`
                                `${size?.unit_capacity?.unit_th}`
                              : `${size?.unit_capacity?.unit_en}`
                          }`
                      : size?.quantity === "size"
                        ? !size?.width && !size?.height && !size?.thickness
                          ? ""
                          : getLocale() === "th"
                            ? `${size?.width ? size?.width : ""}
                          ${
                            size?.unit_width?.unit_th
                              ? size?.unit_width?.unit_th
                              : ""
                          } 
                          ${size?.width ? "x" : ""} 
                          ${size?.height ? size?.height : ""}
                          ${
                            size?.unit_height?.unit_th
                              ? size?.unit_height?.unit_th
                              : ""
                          } 
                          ${size?.height ? "x" : ""} 
                          ${size?.thickness ? size?.thickness : "-"}
                          ${
                            size?.unit_thickness?.unit_th
                              ? size?.unit_thickness?.unit_th
                              : ""
                          }`
                            : `${size?.width ? size?.width : ""}
                          ${
                            size?.unit_width?.unit_en
                              ? size?.unit_width?.unit_en
                              : ""
                          } 
                          ${size?.width && size?.height ? "x" : ""} 
                          ${size?.height ? size?.height : ""}
                          ${
                            size?.unit_height?.unit_en
                              ? size?.unit_height?.unit_en
                              : ""
                          } 
                          ${size?.height && size?.thickness ? "x" : ""} 
                          ${size?.thickness ? size?.thickness : "-"}
                          ${
                            size?.unit_thickness?.unit_en
                              ? size?.unit_thickness?.unit_en
                              : ""
                          }`
                        : ""
                    : size}
                </ProductSize>
              </RowFirst>

              <ClickProductCard>
                <RowFifth>
                  <>
                    {!!price &&
                    price.start_price === 0 &&
                    price.price === 0 &&
                    price.special_price === 0 ? (
                      <WrapperPrice>
                        <WrapperOldPrice />
                        <LabelCurrency>สำหรับข้อมูลเพิ่มเติม</LabelCurrency>
                      </WrapperPrice>
                    ) : price?.is_start_price ? (
                      <WrapperPrice>
                        <WrapperOldPrice>
                          <LabelPriceSmall>ราคาเริ่มต้นที่</LabelPriceSmall>
                        </WrapperOldPrice>
                        <PriceUnitFlex>
                          <SectionPrice>
                            <LabelPrice>
                              {`฿${convertIntToCurrency(
                                price.start_price,
                                false,
                              )}`}
                            </LabelPrice>

                            <LabelCurrency specialprice={false}>
                              {<>/{price?.unit_price?.unit_th}</>}
                            </LabelCurrency>
                          </SectionPrice>
                        </PriceUnitFlex>
                      </WrapperPrice>
                    ) : price?.special_price === 0 && price?.price === 0 ? (
                      <WrapperPrice>
                        <WrapperOldPrice />
                        <LabelCurrency>สำหรับข้อมูลเพิ่มเติม</LabelCurrency>
                      </WrapperPrice>
                    ) : price?.special_price < price?.price &&
                      price?.special_price !== 0 &&
                      price?.special_price !== null ? (
                      <WrapperPrice>
                        <WrapperOldPrice>
                          <LabelPriceSmall isLineThrough={true}>
                            {`฿${convertIntToCurrency(price?.price, false)}`}
                          </LabelPriceSmall>
                        </WrapperOldPrice>
                        <PriceUnitFlex>
                          <SectionPrice>
                            <LabelPrice specialprice={true}>
                              {`฿${
                                convertIntToCurrency(
                                  price?.special_price,
                                  false,
                                )
                                // String(
                                //   convertIntToCurrency(
                                //     price?.special_price,
                                //     false,
                                //   ),
                                // ).split('.').length > 1
                                //   ? convertIntToCurrency(
                                //       price?.special_price,
                                //       false,
                                //     )
                                //   : +convertIntToCurrency(
                                //       price?.special_price,
                                //       false,
                                //     )
                              }`}
                            </LabelPrice>
                            <LabelCurrency specialprice={false}>
                              {<>/{price?.unit_price?.unit_th}</>}
                            </LabelCurrency>
                          </SectionPrice>
                        </PriceUnitFlex>
                      </WrapperPrice>
                    ) : (
                      <WrapperPrice>
                        <WrapperOldPrice />
                        <PriceUnitFlex>
                          <SectionPrice>
                            <LabelPrice>
                              {`฿${convertIntToCurrency(price?.price, false)}`}
                            </LabelPrice>
                            <LabelCurrency specialprice={false}>
                              {<>/{price?.unit_price?.unit_th}</>}
                            </LabelCurrency>
                          </SectionPrice>
                        </PriceUnitFlex>
                      </WrapperPrice>
                    )}
                    {/* <WrapperOrder>
                              <LabelPriceSmall>
                                ขายได้ 1,000
                              </LabelPriceSmall>
                            </WrapperOrder>   
                            <WrapperRating>
                              <FontRating>
                                4.5 ✰
                              </FontRating>
                              
                            </WrapperRating> */}
                  </>
                </RowFifth>
              </ClickProductCard>
            </WrapperDetail>

            {isInstock && !isPreOrder ? (
              <ButtonAddToCart>
                <svg
                  width={25}
                  height={21}
                  viewBox="0 0 23 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  id="icon-cart"
                >
                  <path
                    d="M1 1H3.44186L4.1932 5M4.1932 5L5.88372 14H19.5581L22 5H4.1932Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle cx="6" cy="18" r="2" fill="white" />
                  <circle cx="19" cy="18" r="2" fill="white" />
                </svg>
              </ButtonAddToCart>
            ) : (
              <ButtonAddToCart checkStock>
                เช็ค
                <br /> สต๊อก
              </ButtonAddToCart>
            )}

            {isPreOrder && (
              <ButtonAddToCart isPreOrder>
                พรี
                <br /> ออเดอร์
                {/* <UpdateIcon fontSize="large" /> */}
              </ButtonAddToCart>
            )}
          </Card>
        ) : (
          <Card>
            <WrapperDetail>
              <RowItemcodeView>
                <ItemCode>{itemcode}</ItemCode>
              </RowItemcodeView>

              <RowItemName>
                <LabelItemName>{itemname}</LabelItemName>
              </RowItemName>

              <RowThird>
                <LabelCate>{productType}</LabelCate>
              </RowThird>
            </WrapperDetail>

            <WrapperImage>
              <Image src={src} alt={`${itemname} (${itemcode})`} />
            </WrapperImage>
          </Card>
        )}
      </ProductCard>
    </>
  );
};

export default ProductCardElement;
